import { request } from '@/api/request';
import normalAxios from 'axios';
import qs from 'qs';

const others = {
  // facebook转化API. 正式站才允许调用
  fbApi(data, config = {}, headers = {}) {
    const runtimeConfig = useRuntimeConfig();
    return normalAxios.post(`${runtimeConfig.public.VUE_APP_FB_API}/conversion`, data, {
      config,
      headers,
    });
  },
  // 试戴数据
  tryOn(data) {
    return normalAxios.post('https://tryon.nextmar.com/api/tryon/get_sku_info', qs.stringify(data));
  },
  // tt报告单个事件API，正式站使用
  ttApi(data) {
    try {
      const runtimeConfig = useRuntimeConfig();
      return normalAxios.post(`${runtimeConfig.public.VUE_APP_TT_API}`, data);
    } catch (error) {
      console.error('TikTok API error:', error);
      return Promise.resolve({ error: true });
    }
  },
  // 提交咨询表单
  emailUs(data) {
    return request('/api/public/contact_us', 'post', data);
  },
  // 从 Zendesk 查询文章
  getZendeskAritle(data) {
    return request('/api/public/zendesk_search', 'get', data);
  },
};

export default others;
